/**
 * Lodash Proxy, Loads Lodash 4 and proxies known compatibility issues with postal.js plugins
 * which were written for lodash 3.x
 * To use this, you need the following in the webpack aliases
 * "lodash":path.resolve(__dirname,"external_lib", "postal.custom", "lowerdash.js"),
 * "npmlodash":path.resolve(__dirname,"node_modules", "lodash"),
 * lodash will load this file in the postal libraries
 * npmlodash will reference the real postal build - 4.17.23
 * The only thing using lodash in the SKB build is:
 * postal + postal plugins
 * docdash/html-webpack-plugin/jsdoc (dev dependencies, so won't use webpack aliases)
 * Lowerdash is a custom pre-loader for the lodash components used by postal.js.
 * Build size will increase from lodash 3.10.x but security will be better
 * This should be around 180k (23k minimised).  It can be made smaller using lodash-cli, but lodash-cli is 8 years old
 * and only builds from 4.17.5
 * Written by Paul Brown, 2026/02/05
*/
const after = require("npmlodash/after");
const bind = require("npmlodash/bind");
const clone = require("npmlodash/clone");
const cloneDeep = require("npmlodash/cloneDeep");
const debounce = require("npmlodash/debounce");
const defaults = require("npmlodash/defaults");
const each = require("npmlodash/each");
const extend = require("npmlodash/extend");
const filter = require("npmlodash/filter");
const find = require("npmlodash/find");
const includes = require("npmlodash/includes");
const isArray = require("npmlodash/isArray");
const isEqual = require("npmlodash/isEqual");
const isPlainObject = require("npmlodash/isPlainObject");
const keys = require("npmlodash/keys");
const map = require("npmlodash/map");
const reduce = require("npmlodash/reduce");
const some = require("npmlodash/some");
const throttle = require("npmlodash/throttle");
const without = require("npmlodash/without");

const _ = {
    after, bind, clone, cloneDeep, debounce, defaults,
    //each:each,
    /**/
    //Alternate each implementation to be compatible with lodash 3.x binding
    each:function(targets, callback, binding) {
        if (binding) {
            return each(targets, bind(callback, binding));
        } else {
            return each(targets, callback);
        }
    },
     /**/
    extend,
    filter, find, includes, isArray, isEqual, isPlainObject,
    keys,map, reduce, some, throttle, without,
    //Add some porting for Backward Compatibility laziness
    include:includes,
    contains:includes,
    any:some
};
//export default _;
module.exports = _;